import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import InvoiceExportHistory from './InvoiceExportHistory';
import { Size } from '../../../../../../Enums/Size.enum';

export interface Props extends BaseModalProps {
	isSuperAdmin?: boolean;
}

const InvoiceExportHistoryModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.invoiceExportHistory.modalTitle'
			size={Size.FULLSCREEN}>
			<InvoiceExportHistory isSuperAdmin={props.isSuperAdmin} />
		</BaseModal>
	);
};

export default InvoiceExportHistoryModal;
